
import PhotoSwipeLightbox from "photoswipe/dist/photoswipe-lightbox.esm.js";

export default {
  name: 'PhotoSwipe',
  props: ['items'],
  mounted() {
    const lightbox = new PhotoSwipeLightbox({
      gallerySelector: '#gallery',
      childSelector: 'figure',
      pswpModule: () => import("photoswipe/dist/photoswipe.esm.js"),
      // getThumbBoundsFn: false,
      galleryUID: 1,
      bgOpacity: 1,
      // showHideOpacity: true
      // initialZoomLevel: 'fit',
    })

    // Parse data-pswp-webp-src attribute
    lightbox.addFilter('itemData', (itemData, index) => {
      const webpSrc = this.toWebp(this.items[index].attributes.formats.large.url);
      if (webpSrc) {
        itemData.webpSrc = webpSrc;
      }
      return itemData;
    });

    // use <picture> instead of <img>
    lightbox.on('contentLoad', (e) => {
      const {content, isLazy} = e;

      if (content.data.webpSrc) {
        // prevent to stop the default behavior
        e.preventDefault();

        content.pictureElement = document.createElement('picture');

        const sourceWebp = document.createElement('source');
        sourceWebp.srcset = content.data.webpSrc;
        sourceWebp.type = 'image/webp';

        const sourceJpg = document.createElement('source');
        sourceJpg.srcset = content.data.src;
        sourceJpg.type = 'image/jpeg';

        content.element = document.createElement('img');
        content.element.src = content.data.src;
        content.element.setAttribute('alt', '');
        content.element.className = 'pswp__img';

        content.pictureElement.appendChild(sourceWebp);
        content.pictureElement.appendChild(sourceJpg);
        content.pictureElement.appendChild(content.element);

        content.state = 'loading';

        if (content.element.complete) {
          content.onLoaded();
        } else {
          content.element.onload = () => {
            content.onLoaded();
          };

          content.element.onerror = () => {
            content.onError();
          };
        }
      }
    });

    // by default PhotoSwipe appends <img>,
    // but we want to append <picture>
    lightbox.on('contentAppend', (e) => {
      const {content} = e;
      if (content.pictureElement && !content.pictureElement.parentNode) {
        e.preventDefault();
        content.slide.container.appendChild(content.pictureElement);
      }
    });

    // for next/prev navigation with <picture>
    // by default PhotoSwipe removes <img>,
    // but we want to remove <picture>
    lightbox.on('contentRemove', (e) => {
      const {content} = e;
      if (content.pictureElement && content.pictureElement.parentNode) {
        e.preventDefault();
        content.pictureElement.remove();
      }
    });

    lightbox.on('uiRegister', function () {
      lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el, pswp) => {
          lightbox.pswp.on('change', () => {
            const currSlideElement = lightbox.pswp.currSlide.data.element;
            let captionHTML = '';
            if (currSlideElement) {
              // console.log(currSlideElement)
              const hiddenCaption = currSlideElement.querySelector('.caption');
              // console.log(hiddenCaption)
              if (hiddenCaption) {
                // get caption from element with class hidden-caption-content
                captionHTML = hiddenCaption.innerHTML;
              } else {
                // get caption from alt attribute
                captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
              }
            }
            el.innerHTML = captionHTML || '';
          });
        }
      });
    });

    lightbox.init()
  },
  methods: {
    toWebp(string) {
      return string.replace(/\.(jpg|png)/g, '.webp')
    }
  }
}
